import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageOviedo = props => {
  return <CityLandingPage cityKey="Oviedo" cityConfig={cityContent.oviedo} {...props} />;
};

export default LandingPageOviedo;
